module.exports = __webpack_public_path__ + "img/unicom.fc2cf8f6.png";